import { CheckInStatusEnum } from 'app/shared/enums/check-in-status-type.enum';

import { ContactList, ContactVM } from './contact.models';
import { CompanyReportDTO } from '../customer/customer.model';
import { LocationFullDTO } from '../../../../shared/models/location.model';
import { CustomerCategoryDTO } from 'app/shared/models/customer-category.model';
import { CustomerTypeEnum } from '../../enum/customer-type-enum.enum.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PaymentTermsByChannelDTO, PaymentTermsByChannelVM } from './channel-payment-term.model';
import { CustomValidator } from 'app/shared/utilities/custom-validators.models';

export class CustomerCheckinVM {
  companyInfo: CompanyInfoVM;
  contactInfo: ContactVM[];
  paymentInfo: PaymentInfoVM;
  companyFinancialStatus: CompanyFinancialStatusVM;
  commercialBlock: CommercialBlockVM;
  constructor(init?: Partial<CustomerCheckinVM>) {
    Object.assign(this, init);
    if (!this.companyInfo) this.companyInfo = new CompanyInfoVM();
    if (!this.paymentInfo) this.paymentInfo = new PaymentInfoVM();
    if (!this.companyFinancialStatus) this.companyFinancialStatus = new CompanyFinancialStatusVM();
    if (!this.contactInfo) this.contactInfo = [];
  }
}

export class CommercialBlockVM {
  isCommercialBlock: boolean;
  ordersBlockedByUser: string;
  constructor(init?: Partial<CommercialBlockVM>) {
    Object.assign(this, init);
  }
}

export class CompanyInfoVM {
  vatNumber: string;
  vatPrefix: string;
  listVatPrefix: VatPrefix[];
  pecEmail?: string;
  fiscalCode: string;
  id: number;
  checkInStatus: CheckInStatusEnum;
  lastModificationTime: string;
  creatorId: number;
  lastModifierId: number;
  creationTime: string;
  externalId: string;
  name: string;
  companyFormId?: number;
  sdiCode?: string;
  paCode?: string;
  location: LocationFullDTO;
  customerCategories: CustomerCategoryDTO[];
  customerSelectedCategories: CustomerCategoryDTO[];
  customerType: CustomerTypeEnum;
  listCompanyForm: CompanyFormVM[];

  formGroup?: FormGroup;

  constructor(init?: CompanyInfoVM) {
    Object.assign(this, init);
    if (!this.location) this.location = new LocationFullDTO();
    if (!this.customerCategories) this.customerCategories = [];
    if (!this.customerSelectedCategories) this.customerSelectedCategories = [];
    if (!this.listCompanyForm) this.listCompanyForm = [];
    if (!this.formGroup) this.formGroup = new FormGroup({
      vatNumber: new FormControl({ value: this.vatNumber, disabled: !!this.externalId }),
      fiscalCode: new FormControl(this.fiscalCode),
      name: new FormControl(this.name, Validators.required),
      customerCategories: new FormControl('', Validators.required),
      companyForm: new FormControl(''),
      vatPrefix: new FormControl(this.vatPrefix),
      // companyType: new FormControl('', Validators.required),
      sdiCode: new FormControl(this.sdiCode, [Validators.maxLength(7), Validators.pattern('^[a-zA-Z0-9_.-]*$'), Validators.minLength(7)]),
      paCode: new FormControl(this.paCode, [Validators.maxLength(6), Validators.pattern('^[a-zA-Z0-9_.-]*$'), Validators.minLength(6)]),
      pecEmail: new FormControl(this.pecEmail, [CustomValidator.email()]),
    }, [CustomValidator.checkOnlyProp1OrProp2('sdiCode', 'paCode', 'sdiCodeOrPaCode')]);
  }
}

export class VatPrefix {
  name: string;
  code: string;
  constructor(init?: VatPrefix) {
    Object.assign(this, init);
  }
}
export interface IPaymentInfo {
  paymentTermId: number;
  abi: string;
  cab: string;
  swift: string;
  listPaymentTerm: PaymentTermDto[];
}

export class PaymentInfoVM implements IPaymentInfo {
  paymentTermId: number;
  abi: string;
  cab: string;
  swift: string;
  listPaymentTerm: PaymentTermVM[];
  paymentTermOverrides: PaymentTermsByChannelDTO[];
  constructor(init?: PaymentInfoVM) {
    Object.assign(this, init);
    if (!this.listPaymentTerm) this.listPaymentTerm = [];
  }
}

export interface ICompanyFinancialStatus {
  isCompliantActivity: boolean;
  isCorrectRegistry: boolean;
  isActiveEnterprise: boolean;
  graphReport: number;
}

export class CompanyFinancialStatusVM implements ICompanyFinancialStatus {
  isCompliantActivity: boolean;
  isCorrectRegistry: boolean;
  isActiveEnterprise: boolean;
  graphReport: number;
  cachedReport?: CompanyReportDTO;
}

export class CheckInCompletedVM {
  companyInfo: checkForm;
  contactInfo: checkForm;
  paymentInfo: checkForm;
  companyFinancialStatus: checkForm;
  commercialAgreement: checkForm;
}

export interface IFormList {
  companyInfo: any;
  contactInfo: any;
  paymentInfo: any;
  companyFinancialStatus: any;
  commercialAgreement: any;
}

export interface checkForm {
  value: boolean;
  showError: boolean;
  formGroup?: FormGroup;
}

export class CustomerCategoriesVM implements CustomerCategoryDTO {
  id: number;
  name: string;
  externalId: string;
  isMandatory?: boolean;
  multiSelectCheck?: boolean;
}

export interface ICompanyForm {
  id: number;
  name: string;
  externalId: string;
};

export interface CompanyFormDTO {
  id: number;
  name: string;
  externalId: string;
};

export class CompanyFormVM implements ICompanyForm {
  id: number;
  name: string;
  externalId: string;
  multiSelectCheck?: boolean;

  constructor(init?: CompanyFormVM) {
    Object.assign(this, init);
  }
};
export class PaymentTermDto {
  id: number;
  name: string;
  externalId: string;
  order: number;
  constructor(init?: PaymentTermDto) {
    Object.assign(this, init);
  }
};

export class PaymentTermVM extends PaymentTermDto {
  checked?: boolean;
  constructor(init?: PaymentTermVM) {
    super();
    Object.assign(this, init);
  }
};
export class CustomerDiscountDTO {
  id: number;
  storeId: number;
  customerId: number;
  discount: number;
  validityDateFrom: string;
  validityDateTo: string;
  numOrders: number;
  type: CustomerDiscountTypeEnum;
  constructor(init?: Partial<CustomerDiscountDTO>) {
    Object.assign(this, init);
    if (!this.discount) this.discount = 0;
    if (!this.validityDateFrom) this.validityDateFrom = new Date().toISOString();
    if (!this.validityDateTo) this.validityDateTo = null;
    if (!this.numOrders?.toString()) this.numOrders = 0;
  }
}

export enum CustomerDiscountTypeEnum {
  CatalogDiscount = 1,
  KustomDiscount = 2
} 

export enum FormListPropertyEnum {
  companyInfo = 'companyInfo',
  addressInfo = 'addressInfo',
  contactInfo = 'contactInfo',
  paymentInfo = 'paymentInfo',
  companyFinancialStatus = 'companyFinancialStatus',
  commercialAgreement = 'commercialAgreement'
}

export enum FormControlPropertyEnum {
  markAsUntouched = 1,
  markAllAsTouched = 2,
  freezeFormControl = 3,
  agenciesCustomer = 4,
}
